import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import {
  Button,
  ButtonToolbar,
  Overlay,
  OverlayTrigger,
  Popover,
  Row,
  Tooltip,
} from 'react-bootstrap';
import ButtonV2 from 'components/v2/buttons/Button';
import Dropzone from 'react-dropzone';
import classnames from 'classnames';
import DocumentPreview from 'components/modules/shipments/stops/DocumentPreview';
import { ACCEPTED_FILE_TYPES } from 'config/accepted-file-types';

const dropZoneClassName = classnames(
  'flex',
  'justify-center',
  'items-center',
  'w-full',
  'h-full',
  'border',
  'block',
  'border-dashed',
  'p-4',
  'dropzone-wrapper',
);

class AlreadyConfirmedButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadedFiles: [],
      showOverlay: false,
    };
  }

  handleDrop(files) {
    this.setState({
      uploadedFiles: files,
    });
    this.props.onHandleComplete(files);
  }

  handleRemove(id) {
    const { uploadedFiles } = this.state;
    const newFiles = _.without(
      uploadedFiles,
      _.findWhere(uploadedFiles, { preview: id }),
    );
    this.setState({
      uploadedFiles: newFiles,
    });
  }

  onClear() {
    this.setState({
      uploadedFiles: [],
    });
  }

  renderPreview() {
    const filePreviews = this.state.uploadedFiles.map((file, index) => {
      return (
        <div key={index} className="px-4 py-2">
          <DocumentPreview
            url={file.preview}
            type={file.type}
            name={file.name}
            useFileName
            displayInGridView
            handleRemove={(id) => this.handleRemove(id)}
            removeIconStyles={{
              color: 'red',
              position: 'absolute',
              cursor: 'pointer',
              marginLeft: '0px',
              top: '65px',
            }}
          />
        </div>
      );
    });
    return (
      <div>
        <Row>
          <div className="grid-3-x-3">{filePreviews}</div>
        </Row>
      </div>
    );
  }

  renderUploader() {
    const { t } = this.props;

    return (
      <div>
        <div>
          {this.state.uploadedFiles.length ? this.renderPreview() : null}
        </div>
        <Dropzone
          style={{
            width: '100%',
            height: 100,
          }}
          className={dropZoneClassName}
          onDropAccepted={(files) => this.handleDrop(files)}
          multiple
          accept={ACCEPTED_FILE_TYPES}
        >
          <div>{t('CLICK_DROP_DOC_TO_ADD')}</div>
        </Dropzone>
      </div>
    );
  }

  renderPopup() {
    const { t } = this.props;

    return (
      <Popover
        id="already-confirmed-popup"
        arrowOffsetLeft="90%"
        className="-left-16 flex justify-center"
      >
        <div className="clearfix already-confirmed-filter-wrapper w-64">
          <p>{t('CONFIRMED_RATE_CARD_UPLOAD_VALIDATE_MSG')}</p>
          {this.renderUploader()}
          <ButtonToolbar>
            <Button
              bsStyle="success"
              onClick={() => {
                this.props.alreadyConfirmed(this.props.modalType);
              }}
              bsSize="small"
              disabled={!this.state.uploadedFiles.length}
            >
              {this.props.filesUploading ? t('LOADING') : t('COMPLETE')}
            </Button>
            <Button
              bsStyle="primary"
              onClick={() => this.onClear()}
              bsSize="small"
              disabled={!this.state.uploadedFiles.length}
            >
              {titleize(t('CLEAR'))}
            </Button>
          </ButtonToolbar>
        </div>
      </Popover>
    );
  }

  render() {
    const { t, buttonDisable } = this.props;

    return (
      <div
        className="already-confirmed-button-wrapper"
        testDataId={this.props.testDataId}
      >
        <OverlayTrigger
          container={this}
          trigger="click"
          placement="top"
          overlay={this.renderPopup()}
          rootClose
        >
          <ButtonV2
            className="flex button justify-center items-center px-2"
            disabled={buttonDisable}
          >
            {t('ALREADY_CONFIRMED')}
          </ButtonV2>
        </OverlayTrigger>
      </div>
    );
  }
}

AlreadyConfirmedButton.prototypes = {
  onHandleComplete: PropTypes.func.isRequired,
  buttonDisable: PropTypes.bool.isRequired,
  alreadyConfirmed: PropTypes.func.isRequired,
  testDataId: PropTypes.string,
};

export default withTranslation()(AlreadyConfirmedButton);
